import Photo from "./Photo";
import Reveal from "./Reveal";
import { DoctolibLogo } from "./DoctolibLogo";
import { goTo } from "@/lib/scroll";
import useI18n from "@/i18n";

export default function Hero() {
    const { t } = useI18n();
    return (
        <section id="top" className="halo grad-hero relative overflow-hidden pt-24 md:pt-32" data-testid="hero-section">
            <div className="motif-corner" aria-hidden="true" data-testid="motif-corner" />
            <div className="relative z-10 mx-auto grid max-w-[1080px] items-center gap-10 px-5 pb-20 md:grid-cols-[1.1fr_0.9fr] md:gap-14 md:pb-28">
                <Reveal>
                    <p className="eyebrow">{t.hero.eyebrow}</p>
                    <h1 className="title-grad mt-5 max-w-[16ch] text-4xl sm:text-5xl">
                        {t.hero.h1}
                    </h1>
                    <p className="mt-6 max-w-[54ch] text-ink">{t.hero.sub}</p>
                    <hr className="rule-gold mt-5 w-24" />
                    <p
                        className="mt-5 max-w-[56ch] text-sm text-ink2"
                        data-testid="hero-specialites"
                    >
                        {t.hero.specialites}
                    </p>
                    <div className="mt-8 flex flex-wrap items-center gap-6">
                        <a
                            href="#rdv"
                            onClick={(e) => goTo(e, "#rdv")}
                            data-testid="hero-rdv-button"
                            className="btn btn-primary px-7"
                        >
                            {t.hero.cta}
                        </a>
                        <a
                            href="#soins"
                            onClick={(e) => goTo(e, "#soins")}
                            data-testid="hero-soins-link"
                            className="link-underline font-bold text-terrat"
                        >
                            {t.hero.link}
                        </a>
                    </div>
                    <p
                        className="mt-6 flex flex-wrap items-center gap-2 text-sm text-ink2"
                        data-testid="hero-doctolib-mention"
                    >
                        {t.hero.doctolibMention}
                        <DoctolibLogo height={19} />
                    </p>
                </Reveal>
                <Reveal delay={0.15}>
                    <Photo
                        file="accueil.jpg"
                        alt={t.hero.photoAlt}
                        eager
                        position="50% 50%"
                        ratioClass="arch aspect-[4/5]"
                        className="mx-auto w-full max-w-[320px] md:mx-0 md:ml-auto md:max-w-[440px]"
                        data-testid="hero-photo"
                    />
                </Reveal>
            </div>
        </section>
    );
}
